/* eslint-disable internal-rules/agg-product-areas */
import { convertConfigForAggregation } from '@/utils/date-range.utils.js';
import {
    basicPipeline,
    COMMON_VOC_LINKED_ITEMS_AGG_PIPELINE,
    INCLUDE_USERS_FOR_VOCITEMS,
} from '@/voc/helpers/aggs.helper';
import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS } from '@utils/aggregation';

const { VOC, VALIDATE } = PRODUCT_AREAS || {};

export default {
    name: 'VocItemsAggregation',
    productArea: VOC,
    subProductArea: VALIDATE,
    responseFormat: 'rows',
    response: ({ isCsv = false, columns, type = 'idea' }) => {
        if (isCsv) {
            return {
                location: 'gcs',
                mimeType: 'text/csv',
                fields: columns,
                name: `${type}-${new Date().getTime()}.csv`,
            };
        }

        return {
            location: 'request',
            mimeType: 'application/json',
        };
    },
    build: ({
        type = 'idea',
        appId = 'expandAppIds("*")',
        voteSegmentId,
        segmentId,
        alert = [],
        allTime,
        timeSeries,
        timeSeriesConfig,
        revenueField,
        accountDisplayName,
        accountTypeField,
        countOnly = false,
        groups = [],
        statuses = [],
        createdBy = [],
        importance = [],
        labels = [],
        searchText = '',
        linkedIdeas = [],
        workarounds = [],
        sources = [],
        account,
        visitor,
        accountTypes = [],
        npsScores = [],
        vocInsightIds = [],
        feedbackType = [],
        competitorNames = [],
        includeSuggestions = false,
        assignee = [],
        expandInsights = false,
        limit = 0,
        sortBy,
        isCsv = false,
        portals = [],
        accessibleGroupIds = [],
        accessibleAppIds = [],
        unattributedOnly = false,
        votedByVisitorId = null,
        showSuggestionCountOverflow = false,
    }) => {
        timeSeriesConfig ??= timeSeries ? convertConfigForAggregation(timeSeries?.config || timeSeries) : null;
        allTime = allTime || !timeSeriesConfig;
        voteSegmentId ??= segmentId;

        const agg = basicPipeline({
            appId,
            type,
            voteSegmentId,
            alert,
            allTime,
            timeSeries: timeSeriesConfig,
            revenueField,
            accountDisplayName,
            accountTypeField,
            groups,
            statuses,
            createdBy,
            importance,
            labels,
            searchText,
            linkedIdeas,
            workarounds,
            sources,
            account,
            visitor,
            accountTypes,
            npsScores,
            vocInsightIds,
            feedbackType,
            competitorNames,
            includeSuggestions,
            assignee,
            expandInsights,
            sortBy,
            isCsv,
            limit,
            portals,
            accessibleGroupIds,
            accessibleAppIds,
            unattributedOnly,
            votedByVisitorId,
            showSuggestionCountOverflow,
        });

        agg.fork.push(...INCLUDE_USERS_FOR_VOCITEMS({ sortBy }));

        if (type === 'feedback') {
            agg.fork.push(COMMON_VOC_LINKED_ITEMS_AGG_PIPELINE({ isCsv }));
        }

        const pipe = o.pipeline(
            agg.source,
            ...[
                ...agg.pipeline,
                o.sort(sortBy),
                ...(limit ? [o.limit(limit)] : []),
                ...(agg.fork.length > 1 ? [o.fork(...agg.fork), o.join('id')] : []),
                ...(agg.fork.length === 1 ? agg.fork[0] : []),
                ...(agg.postFork.length ? o.pipeline(...agg.postFork) : []),
                ...(isCsv ? [o.sort(sortBy)] : []),
                ...(isCsv ? [
                    o.evaluate('lastUpdatedAt', 'formatTime("Jan 2, 2006 3:04 PM", lastUpdatedAt)'),o.evaluate('createdAt', 'formatTime("Jan 2, 2006 3:04 PM", createdAt)'),
                ] : []),
                ...(searchText.length > 0 ? [o.sort('-score')] : []),
                agg.select,
            ],
        );

        if (countOnly) {
            pipe.push(o.reduce({ count: o.count(null), totalVotes: o.sum('voteCount') }));
        }

        return pipe;
    },
};
